angular.module('unergie.main')
.controller('fslHistoryModalCtrl', ($scope, $uibModalInstance, NgTableParams, account) => {
    $scope.close = $uibModalInstance.dismiss

    $scope.statusMap = { REQUESTED: 'Demandé', GRANTED: 'Accordé', REJECTED: 'Refusé', RECEIVED: 'Paiement reçu' }

    const init = () => {
        $scope.checksTable = new NgTableParams({ sorting: { request_date: 'desc' }, count: 10 }, { dataset: account.fsls, counts: [] })
    }

    init()
})
